var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-block-heading",class:_vm.classes},[(_vm.block.value.upper)?_c('h2',{staticClass:"cms-block-heading__upper"},[_vm._v(" "+_vm._s(_vm.block.value.upper)+" ")]):_vm._e(),(_vm.block.value.lower)?_c('h2',{staticClass:"cms-block-heading__lower"},[_vm._v(" "+_vm._s(_vm.block.value.lower)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }